import {ChangesType} from '../../../../types'

export const getDefaultChangesType = (changesCount: number): ChangesType =>
  changesCount > 0 ? ChangesType.CHANGES : ChangesType.ARTIFACTS
